import script from "./UpdateHoliday.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpdateHoliday.vue?vue&type=script&lang=ts&setup=true"

import "./UpdateHoliday.vue?vue&type=style&index=0&id=2d161481&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d161481"]])

export default __exports__